/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Ein Wert der Kreuztabelle — Feld, Rechenart und Suffix.
 * @export
 * @interface GespeicherteAuswertungWert
 */
export interface GespeicherteAuswertungWert {
    /**
     * Feld-Kennung, oder `__ID__` fuer „Anzahl der Datensaetze".
     * @type {string}
     * @memberof GespeicherteAuswertungWert
     */
    feld?: string;
    /**
     * SUMME, DURCHSCHNITT, ANZAHL, MINIMUM, MAXIMUM oder VERHAELTNIS.
     * BEWUSST EIN TEXT UND KEIN ENUM: Kommt eine Rechenart dazu, koennte ein aelteres Backend ein Lesezeichen sonst nicht mehr annehmen — und ein Lesezeichen, das beim Speichern mit 400 abgewiesen wird, sieht aus wie ein kaputter Knopf. Geprueft wird beim LESEN, so wie es `auswertungSpeicher.ts` mit dem gemerkten Wunsch schon haelt.
     * @type {string}
     * @memberof GespeicherteAuswertungWert
     */
    rechenart?: string;
    /**
     * Steht hinter der Zahl, etwa „EUR".
     * @type {string}
     * @memberof GespeicherteAuswertungWert
     */
    suffix?: string;
}

/**
 * Check if a given object implements the GespeicherteAuswertungWert interface.
 */
export function instanceOfGespeicherteAuswertungWert(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GespeicherteAuswertungWertFromJSON(json: any): GespeicherteAuswertungWert {
    return GespeicherteAuswertungWertFromJSONTyped(json, false);
}

export function GespeicherteAuswertungWertFromJSONTyped(json: any, ignoreDiscriminator: boolean): GespeicherteAuswertungWert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feld': !exists(json, 'feld') ? undefined : json['feld'],
        'rechenart': !exists(json, 'rechenart') ? undefined : json['rechenart'],
        'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
    };
}

export function GespeicherteAuswertungWertToJSON(value?: GespeicherteAuswertungWert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feld': value.feld,
        'rechenart': value.rechenart,
        'suffix': value.suffix,
    };
}

